import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/ConfirmationDialog';

const RestreamingFailureModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('modals');

  const handleCancel = () => {
    dispatch(closeModal('restreamingFailure'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('restreaming.failure.title')}
      description={t('restreaming.failure.description')}
      okText={t('restreaming.failure.btn_ok_label')}
      onOk={handleCancel}
      onCancel={handleCancel}
    />
  );
};

export default RestreamingFailureModal;
